import * as React from 'react'
import * as css from './Stat.module.css'
import clsx from 'clsx'

const Stat = ({ number, arrow, text, className }) => (
  <dl className={clsx(className, 'max-w-min')}>
    <dt className={clsx(!!arrow && css[arrow], 'h1 flex items-center text-ft-green')}>{number || 0}</dt>
    <dd className="technical">{text}</dd>
  </dl>
)

const StatList = ({ className, children }) => (
  <div
    className={[className, css.list].join` `}
    style={{ '--col': children.length > 4 ? 3 : 2 }}
  >
    {children}
  </div>
)

export {
  Stat,
  StatList,
}
